<template>
  <div v-html="printHtml"></div>
</template>
<script>
export default {
  props: ["printData",'printTitle'],
  data() {
    return {
      printHtml: "",
    };
  },
  mounted() {
  },
  methods: {
    setPrintHtml(title) {
      this.printHtml = `<h2><center>${(this.printTitle?this.printTitle:'') || title }</center></h2>`;
      this.printData.forEach((item) => {
        this.printHtml += "<table  width='100%'>";
        this.printHtml += "<tr>";
        this.printHtml += "<td width='20%'>" + item.label + "</td>";
        this.printHtml += "<td width='80%'>" + item.value + "</td>";
        this.printHtml += "</tr>";
        this.printHtml += "</table>";
      });
    },
  },
};
</script>
<style  media="print">

/*避免出现空白尾页*/
html,
body,
#app {
  height: 98% !important;
  margin: 0px;
  padding: 0px;
}

</style>
